/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable default-case */
import * as storage from "../services/localStorage";
import { LOGIN, SIGN_UP, LOG_OUT, UPDATE_AUTH } from "../constant/index";
import { resolveMediaUrl } from "../utils/userIdentity";
import { isDealerUser, pickUserType } from "../utils/userTypes";
import {
  clearSyncedDealersSession,
  syncDealersSessionFromAuthState,
  syncDealersSessionFromHomeLogin,
} from "../utils/dealerSessionSync";

const INITIAL_STATE = {
  SIGN_UP_done: false,
  loging: false,
  creating: false,
  isLogedin: false,
  token: "",
  expiry: "",
  email: "",
  firstname: "",
  lastname: "",
  username: "",
  id: "",
  image: "",
  mobile_number: "",
  postcode: "",
  type: null,
  referral_code: "",
  credits: null,
  last_evaluation: "",
};

function pickLoginImage(source = {}, nested = {}) {
  const raw =
    source.image ||
    source.image_url ||
    source.profile_image ||
    source.profile_image_url ||
    source.avatar ||
    source.avatar_url ||
    nested.image ||
    nested.image_url ||
    nested.profile_image ||
    nested.profile_image_url ||
    nested.avatar ||
    nested.avatar_url ||
    "";
  return resolveMediaUrl(raw) || "";
}

function looksLikeUser(obj) {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) return false;
  return Boolean(
    obj.first_name != null ||
      obj.firstname != null ||
      obj.last_name != null ||
      obj.lastname != null ||
      obj.email != null ||
      obj.username != null ||
      obj.id != null ||
      obj.user_id != null ||
      obj.pk != null
  );
}

function unwrapLoginUser(payload = {}) {
  if (looksLikeUser(payload.user)) return payload.user;
  if (looksLikeUser(payload.data?.user)) return payload.data.user;
  if (looksLikeUser(payload.data)) return payload.data;
  if (looksLikeUser(payload)) return payload;
  return {};
}

function normalizeLoginPayload(payload = {}) {
  const user = unwrapLoginUser(payload);
  const source = {
    ...user,
    ...payload,
  };

  const first =
    user.firstname ||
    user.first_name ||
    source.firstname ||
    source.first_name ||
    "";
  const last =
    user.lastname ||
    user.last_name ||
    source.lastname ||
    source.last_name ||
    "";

  return {
    token: source.token || user.token || source.key || "",
    expiry: source.expiry || "",
    email: user.email || source.email || "",
    firstname: first,
    lastname: last,
    username: user.username || source.username || "",
    id:
      user.id ||
      user.user_id ||
      user.pk ||
      source.id ||
      source.user_id ||
      source.pk ||
      "",
    image: pickLoginImage(source, user),
    mobile_number:
      user.mobile_number ||
      user.phone ||
      user.mobile ||
      source.mobile_number ||
      source.phone ||
      "",
    postcode:
      user.postcode ||
      user.postal_code ||
      source.postcode ||
      source.postal_code ||
      "",
    type: pickUserType(user, source, payload),
    referral_code:
      user.referral_code ||
      user.code ||
      source.referral_code ||
      source.code ||
      source.referral ||
      "",
    credits:
      user.credits != null
        ? user.credits
        : user.credit != null
          ? user.credit
          : source.credits != null
            ? source.credits
            : source.credit != null
              ? source.credit
              : null,
    last_evaluation:
      user.last_evaluation ||
      user.lastEvaluation ||
      source.last_evaluation ||
      source.lastEvaluation ||
      "",
  };
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${LOGIN}_REQUEST`:
      return {
        ...INITIAL_STATE,
        loging: true,
      };

    case `${LOGIN}_SUCCESS`: {
      const normalized = normalizeLoginPayload(action.payload);
      const nextState = {
        ...state,
        ...normalized,
        loging: false,
        isLogedin: Boolean(normalized.token),
      };
      storage.set({
        key: "auth",
        data: nextState,
      });
      if (isDealerUser(nextState)) {
        syncDealersSessionFromHomeLogin(nextState);
      }
      return nextState;
    }

    case `${LOGIN}_FAIL`:
    case `${LOGIN}_ERROR`:
      return {
        ...state,
        loging: false,
      };

    case UPDATE_AUTH: {
      const patch = { ...(action.payload || {}) };
      if (Object.prototype.hasOwnProperty.call(patch, "image")) {
        const nextImage = resolveMediaUrl(patch.image);
        // Never wipe a known-good avatar with an empty/null API value.
        if (!nextImage && state.image) {
          delete patch.image;
        } else {
          patch.image = nextImage;
        }
      }
      const nextState = {
        ...state,
        ...patch,
      };
      storage.set({
        key: "auth",
        data: nextState,
      });
      if (isDealerUser(nextState)) {
        syncDealersSessionFromAuthState(nextState);
      }
      return nextState;
    }

    case `${SIGN_UP}_REQUEST`:
      return {
        ...state,
        creating: true,
      };

    case `${SIGN_UP}_SUCCESS`:
      return {
        ...state,
        creating: false,
        SIGN_UP_done: action.payload,
      };

    case `${SIGN_UP}_FAIL`:
    case `${SIGN_UP}_ERROR`:
      return {
        ...state,
        creating: false,
      };

    case LOG_OUT:
      if (isDealerUser(state)) {
        clearSyncedDealersSession();
      }
      storage.remove({
        key: "auth",
      });
      return INITIAL_STATE;
  }
  return state;
};
